module.exports = __webpack_public_path__ + "img/card_program@2x.9bf27072.png";